module.exports = __webpack_public_path__ + "img/381.742f131c.png";